import React, {useEffect, useState} from 'react';
import {
    Grid,
    Typography,
    Select,
    MenuItem,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from '@material-ui/core';
import WidgetCard from './WidgetCard';
import VesselIcon from './icons/VesselIcon';
import {PrettyFloatDays} from './SeaservicesJumbo';
import content from 'components/widgets/tooltips/InfoModalContent';
import {makeStyles} from '@material-ui/core/styles';
import {useFlags} from 'hooks';

const useStyles = makeStyles(theme => ({
    container: {},
    selectWrapper: {
        textAlign: 'center',
        marginBottom: '1em',
    },
    vesselIconWrapper: {
        textAlign: 'center',
    },
    tableWrapper: {
        textAlign: 'center',
        marginBottom: '1em',
    },
    tableContainer: {
        margin: '0 auto',
        width: '65%',
        overflow: 'hidden',
    },
    tableHeader: {
        background: 'white',
        border: 'none',
    },
    tableHeaderCell: {
        backgroundColor: theme.palette.primary.main,
        textAlign: 'center',
        padding: '.25em',
        border: 'none',
    },
    tableCell: {
        color: theme.palette.primary.white,
        backgroundColor: theme.palette.charts.inandBlue,
        textAlign: 'center',
        padding: '0',
    },
    typography: {
        color: theme.palette.primary.white,
        fontWeight: '500',
    },
}));

const iconStyle = {
    style: {
        maxWidth: '30%',
    },
};

const validVesselTypes = ves => {
    return ves.credit?.total > 0 && ves.category !== 'Motor Vessel';
};

const SeaServiceVesselType = ({sss, ...props}) => {
    const classes = useStyles();
    const {sea_service_vessel_type_widget_active} = useFlags();
    const {data: seaservice, isLoading, error} = sss;

    const [types, setTypes] = useState(
        seaservice?.vessel?.filter(validVesselTypes) || []
    );
    const [type, setType] = useState('placeholder');
    const [data, setData] = useState(
        seaservice?.vessel?.find(item => item.category === type) || {}
    );

    useEffect(() => {
        if (seaservice && Array.isArray(seaservice?.vessel)) {
            setTypes(seaservice?.vessel?.filter(validVesselTypes) || []);
            setType(
                seaservice?.vessel?.find(validVesselTypes)?.category ||
                    'placeholder'
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seaservice]);

    useEffect(() => {
        setData(seaservice?.vessel?.find(item => item.category === type) || {});
        // eslint-disable-next-line
    }, [type]);

    return (
        <WidgetCard
            title='Vessel Breakdown'
            hasData={sea_service_vessel_type_widget_active && types?.length}
            isLoading={isLoading}
            error={error}
            infoModalContent={content.vessel}
            {...props}
        >
            <Grid container className={classes.container}>
                <Grid item xs={12} className={classes.selectWrapper}>
                    <Select
                        label='Vessel Type'
                        value={type}
                        onChange={event => setType(event.target.value)}
                    >
                        {types.map(item => (
                            <MenuItem key={item.category} value={item.category}>
                                {item.category}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={12} className={classes.vesselIconWrapper}>
                    <VesselIcon {...iconStyle} vesselType={type} />
                </Grid>
                <Grid item xs={12} className={classes.tableWrapper}>
                    <TableContainer className={classes.tableContainer}>
                        <Table aria-label='Sea Days Credit table'>
                            <TableHead className={classes.tableHeader}>
                                <TableRow>
                                    <TableCell
                                        className={classes.tableHeaderCell}
                                    >
                                        <Typography
                                            variant='h6'
                                            className={classes.typography}
                                        >
                                            Sea Days Credit
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableCell className={classes.tableCell}>
                                    <Typography
                                        variant='h2'
                                        className={classes.typography}
                                    >
                                        <PrettyFloatDays
                                            days={data?.credit?.total}
                                        />
                                    </Typography>
                                </TableCell>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} className={classes.tableWrapper}>
                    <TableContainer className={classes.tableContainer}>
                        <Table aria-label='Sea Days Credit Last Three Years table'>
                            <TableHead className={classes.tableHeader}>
                                <TableRow>
                                    <TableCell
                                        className={classes.tableHeaderCell}
                                    >
                                        <Typography
                                            variant='h6'
                                            className={classes.typography}
                                        >
                                            Last Three Years
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableCell className={classes.tableCell}>
                                    <Typography
                                        variant='h2'
                                        className={classes.typography}
                                    >
                                        <PrettyFloatDays
                                            days={
                                                data?.credit && data.credit['3']
                                            }
                                        />
                                    </Typography>
                                </TableCell>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </WidgetCard>
    );
};

export default SeaServiceVesselType;
